import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { GridState } from 'ag-grid-community';

@Injectable({
  providedIn: 'root'
})
export class UserGridStateService {
  
  private gridStates = new BehaviorSubject<{ [key: string]: GridState | null }>({});

  constructor(private http: HttpClient) {}

  public getUserGridState(gridId: string): Observable<GridState | null> {
    const allGridStates = JSON.parse(localStorage.getItem('allGridStates') || '{}');
    let gridState = allGridStates[gridId];

    if (gridState) {
      return of(gridState);
    } else {
      return this.http.get<{ grid_states: Array<{ [key: string]: any }> }>('/api/grid_states.php').pipe(
        map(response => {
          const stateWrapper = response.grid_states.find(state => state.hasOwnProperty(gridId));
          gridState = stateWrapper ? stateWrapper[gridId] : null;
          
          if (gridState) {
            allGridStates[gridId] = gridState;
            localStorage.setItem('allGridStates', JSON.stringify(allGridStates));
            return gridState;
          }
          return null;
        }),
        catchError(error => {
          console.error('Error fetching grid state:', error);
          return throwError(() => new Error('Error fetching grid state'));
        })
      );
    }
  }

  // save both locally and on the backend
  public saveUserGridState(gridId: string, gridState: GridState): void {
    this.http.post(`/api/grid_states.php`, { gridId, gridState })
      .pipe(
        catchError(error => {
          console.error('Error saving grid state:', error);
          return throwError(() => new Error('Error saving grid state: ' + error.message));
        }),
        tap(() => this.updateLocalAndBehaviorSubject(gridId, gridState))
      )
      .subscribe(() => console.log('Grid state saved successfully'));
  }

  // updates local storage and the BehaviorSubject with the new grid state
  private updateLocalAndBehaviorSubject(gridId: string, gridState: GridState) {
    const currentStates = JSON.parse(localStorage.getItem('allGridStates') || '{}');
    currentStates[gridId] = gridState;
    localStorage.setItem('allGridStates', JSON.stringify(currentStates));

    const updatedStates = this.gridStates.getValue();
    updatedStates[gridId] = gridState;
    this.gridStates.next(updatedStates);
  }
}